import { Area, AreaChart, Bar, BarChart, CartesianGrid, Cell, Legend, Line, LineChart, Pie, PieChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { tooltipStyle } from "@/components/common";
import { CHART, chartAxis, money, shortDay } from "@/lib/format";

export function RevenueChart({ data, gran = "day", height = 260, keys = ["revenue"] }) {
  const labels = { ppv: "PPV", tips: "Tips", other: "Custom/Altro", revenue: "Fatturato" };
  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart data={data}>
        <defs>
          {keys.map((k, i) => (
            <linearGradient key={k} id={`g-${k}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={CHART[i]} stopOpacity={0.45} /><stop offset="100%" stopColor={CHART[i]} stopOpacity={0} />
            </linearGradient>
          ))}
        </defs>
        <CartesianGrid stroke="#1A1D2B" vertical={false} />
        <XAxis dataKey="t" tickFormatter={(t) => shortDay(t, gran)} {...chartAxis} minTickGap={20} />
        <YAxis {...chartAxis} width={50} tickFormatter={(v) => `€${v >= 1000 ? `${(v / 1000).toFixed(1)}k` : v}`} />
        <Tooltip {...tooltipStyle} labelFormatter={(t) => shortDay(t, gran)} formatter={(v, n) => [money(v), labels[n] || n]} />
        {keys.map((k, i) => <Area key={k} type="monotone" dataKey={k} stackId="1" stroke={CHART[i]} fill={`url(#g-${k})`} strokeWidth={2} />)}
      </AreaChart>
    </ResponsiveContainer>
  );
}

export function HBar({ data, height = 260, valueKey = "revenue", fmt = money }) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data.slice(0, 10)} layout="vertical" margin={{ left: 10 }}>
        <CartesianGrid stroke="#1A1D2B" horizontal={false} />
        <XAxis type="number" {...chartAxis} tickFormatter={(v) => (fmt === money ? `€${v}` : v)} />
        <YAxis type="category" dataKey="name" {...chartAxis} width={100} />
        <Tooltip {...tooltipStyle} cursor={{ fill: "rgba(124,58,237,0.08)" }} formatter={(v) => fmt(v)} />
        <Bar dataKey={valueKey} radius={[0, 4, 4, 0]}>
          {data.slice(0, 10).map((_, i) => <Cell key={i} fill={CHART[i % CHART.length]} />)}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}

export function MsgChart({ data, gran = "day", height = 220 }) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data}>
        <CartesianGrid stroke="#1A1D2B" vertical={false} />
        <XAxis dataKey="t" tickFormatter={(t) => shortDay(t, gran)} {...chartAxis} minTickGap={20} />
        <YAxis {...chartAxis} width={36} />
        <Tooltip {...tooltipStyle} labelFormatter={(t) => shortDay(t, gran)} />
        <Legend wrapperStyle={{ fontSize: 11 }} />
        <Bar dataKey="msg_in" name="Ricevuti" fill="#3B82F6" radius={[3, 3, 0, 0]} />
        <Bar dataKey="msg_out" name="Inviati" fill="#7C3AED" radius={[3, 3, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}

export function LineSeries({ data, lines, gran = "day", height = 220, isMoney = false }) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data}>
        <CartesianGrid stroke="#1A1D2B" vertical={false} />
        <XAxis dataKey="t" tickFormatter={(t) => shortDay(t, gran)} {...chartAxis} minTickGap={20} allowDuplicatedCategory={false} />
        <YAxis {...chartAxis} width={44} />
        <Tooltip {...tooltipStyle} labelFormatter={(t) => shortDay(t, gran)} formatter={(v) => (isMoney ? money(v) : v)} />
        <Legend wrapperStyle={{ fontSize: 11 }} />
        {lines.map((l, i) => <Line key={l.key} data={l.data} type="monotone" dataKey={l.dataKey || l.key} name={l.name} stroke={CHART[i % CHART.length]} strokeWidth={2} dot={false} />)}
      </LineChart>
    </ResponsiveContainer>
  );
}

export function Donut({ data, height = 220 }) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <PieChart>
        <Pie data={data} dataKey="value" nameKey="name" innerRadius={55} outerRadius={85} paddingAngle={3} stroke="none">
          {data.map((_, i) => <Cell key={i} fill={CHART[i % CHART.length]} />)}
        </Pie>
        <Tooltip {...tooltipStyle} formatter={(v) => money(v)} />
        <Legend wrapperStyle={{ fontSize: 11 }} />
      </PieChart>
    </ResponsiveContainer>
  );
}
